function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDown = function SvgDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 1024 1024"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M512 753.2c-8.8 0-17.6-3.4-24.4-10.1L74.1 329.6c-13.5-13.4-13.5-35.3 0-48.7 13.4-13.5 35.3-13.5 48.7 0L512 670l389.2-389.1c13.6-13.5 35.2-13.5 48.8 0 13.4 13.4 13.4 35.3 0 48.7L536.3 743.1c-6.7 6.7-15.5 10.1-24.3 10.1",
    style: {
      fill: "#333"
    }
  }));
};
export default SvgDown;